import { Menu } from "antd";
import { FaEllipsisV } from "react-icons/fa";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: flex-start;

  &:not(:first-of-type) {
    padding-top: 20px;
  }

  &:not(:last-of-type) {
    padding-bottom: 20px;
  }

  color: ${({ theme }) => theme.colors.textColor};

  .left-col {
    display: flex;
    margin-right: 20px;
    align-items: center;

    .user-avatar {
      margin-right: 10px;

      img {
        border-radius: 50%;
      }

      .SimpleUserInitialsName {
        width: 1.875rem;
        height: 1.875rem;

        h1 {
          font-size: 0.75rem;
        }
      }
    }

    .username-and-date-container {
      width: 140px;
      display: flex;
      flex-direction: column;

      h4 {
        margin: -1px 0 3px;
      }

      span {
        color: #aaa;
        font-size: 12px;
      }
    }
  }

  .right-col {
    display: flex;
    flex-direction: column;

    .review-rate {
      margin: -5px 0 10px;
    }

    p {
      text-align: justify;
      margin-bottom: 0;
    }
  }

  @media screen and (max-width: 1300px) {
    flex-direction: column;

    .left-col {
      margin-bottom: 15px;
    }
  }
`;

export const CustomMenu = styled(Menu)`
  background: ${({ theme }) => theme.colors.backgroundColor};
  .ant-dropdown-menu-item {
    color: ${({ theme }) => theme.colors.textColor};
  }
`;

export const IconFaEllipsisV = styled(FaEllipsisV)`
  position: absolute;
  cursor: pointer;
  font-size: 16px;
  right: 20px;
  color: ${({ theme }) => theme.colors.textColor};
`;
